import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'

import { SelectOption } from '../../../components/SelectDropdown/SelectDropdown'

import { User } from '../../../models/User'

export const MAX_DOCUMENT_BATCH_FILES = 10

export const MAX_DOCUMENT_FILE_SIZE_BYTES = 20 * 1024 * 1024

export enum DocumentUploadSource {
  ZOCKS = 'zocks',
  INTEGRATION = 'integration',
}

const CONTENT_TYPE_BY_EXTENSION: Record<string, string> = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  txt: 'text/plain',
  csv: 'text/csv',
}

export const inferContentType = (name: string): string => {
  const extension = name.split('.').pop()?.toLowerCase()
  return (extension && CONTENT_TYPE_BY_EXTENSION[extension]) || 'application/octet-stream'
}

export const zocksUserToSelectOption = (user: User): SelectOption => {
  const displayName = getUserDisplayName(user)
  return {
    id: user.id,
    label: `${displayName} (${user.email})`,
  }
}

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) {
    return '0 B'
  }

  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

export const hashFile = async (file: File) => {
  const buffer = await file.arrayBuffer()
  const digest = await crypto.subtle.digest('SHA-256', buffer)
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('')
}

export const isFileSizeValid = (bytes: number) => {
  return bytes > 0 && bytes <= MAX_DOCUMENT_FILE_SIZE_BYTES
}
